import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const RulesIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" fill="none">
		<path
			fill="#6175DB"
			fillRule="evenodd"
			d="M12.25 1.48v3.057c0 .11 0 .27.02.406a.937.937 0 0 0 .445.683.96.96 0 0 0 .783.072c.13-.04.272-.108.378-.16L15 5.006l1.124.534c.106.05.248.119.378.16a.958.958 0 0 0 .783-.073.936.936 0 0 0 .444-.683c.021-.136.021-.295.021-.406V.03c.113-.005.224-.01.332-.013C19.154-.02 20 .86 20 1.933v11.21c0 1.112-.906 2.01-2.015 2.08-.97.06-2.108.179-2.985.41-1.082.286-1.99 1.068-3.373 1.436-.626.167-1.324.257-1.627.323V2.174c.32-.08 1.382-.203 1.674-.371.184-.107.377-.216.576-.323Zm5.478 8.338a.75.75 0 0 1-.546.91l-4 1a.75.75 0 1 1-.364-1.456l4-1a.75.75 0 0 1 .91.546Z"
			clipRule="evenodd"
		/>
		<path
			fill="#6175DB"
			d="M16.25.15c-.62.074-1.23.18-1.75.337a8.206 8.206 0 0 0-.75.27v3.182l.75-.356.008-.005c.152-.08.32-.125.492-.13.047 0 .094.004.138.01.175.029.315.1.354.12l.009.005.749.356V.15Z"
		/>
		<path
			fill="#6175DB"
			d="M10 2.214c-.334-.064-1.057-.161-1.718-.34C6.938 1.515 6.05.765 5 .488 4.113.253 2.959.135 1.982.075.886.007 0 .9 0 1.998v11.146c0 1.11.906 2.01 2.015 2.079.97.06 2.108.179 2.985.41.486.129 1.216.43 1.873.726 1.005.45 2.052.797 3.127 1.034V2.213Z"
			opacity=".3"
		/>
		<path
			fill="#6175DB"
			d="M2.273 9.818a.75.75 0 0 1 .91-.545l4 1a.75.75 0 0 1-.365 1.455l-4-1a.749.749 0 0 1-.545-.91Zm.909-4.545a.75.75 0 1 0-.364 1.455l4 1a.75.75 0 0 0 .364-1.455l-4-1Z"
		/>
	</svg>
);
